import { css } from 'linaria';

export const linkWrap = css`
  width: 280px;
`;

export const link = css`
  width: 100%;

  display: grid !important;
  grid-template-columns: auto 1fr auto;
  padding: var(--space-100) var(--space-150) !important;

  @media (hover: hover) {
    &:hover {
      &::before {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }

      &::after {
        content: '';
        display: block;
        position: absolute;

        background-color: var(--background-secondary);
        z-index: -1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
`;
